export enum WalletProductValidation {
	AtleastOneTypeSelected,
}
